// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mb__header-icon.CategoryOption[status=alert][data-v-8d450d26]{animation:categoryOptionBlink-8d450d26 1s steps(1) infinite}@keyframes categoryOptionBlink-8d450d26{50%{opacity:.2}}", ""]);
// Exports
module.exports = exports;
